import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Trophy } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import BadgeShare from "./BadgeShare";

export default function ChampionBadge() {
  const { user } = useAuth();
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/driver-card/champion").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c?.champion || !user) return null;
  const b = c.best;
  return (
    <section className="p-5 rounded-2xl border bg-orange-400/10 border-orange-400/40 flex items-center gap-4" data-testid="champion-badge-card">
      <div className="w-14 h-14 rounded-full flex items-center justify-center shrink-0 bg-orange-400 text-slate-950 shadow-[0_0_30px_-5px_rgba(251,146,60,.8)]"><Trophy className="w-7 h-7" /></div>
      <div className="flex-1 min-w-0">
        <p className="font-mono text-[10px] tracking-widest uppercase text-slate-400">Badge earned{c.times > 1 ? ` · ${c.times}× champion` : ""}</p>
        <h3 className="font-display font-bold" data-testid="champion-badge-title">Streak Champion — #{b.rank} · {b.weeks}-week streak</h3>
        <p className="text-xs text-orange-200/80 mt-0.5 inline-flex items-center gap-1"><Flame className="w-3 h-3" />Week of {b.week}{b.tier ? ` · ${b.tier}` : ""}. <Link to="/community/g/gig-drivers" className="underline underline-offset-2">See the board</Link></p>
        <div className="mt-3"><BadgeShare userId={user.id} name={user.name} kind="champion" text={`I'm a MY VELOCITY Streak Champion — #${b.rank} with a ${b.weeks}-week on-time delivery streak!`} /></div>
      </div>
    </section>
  );
}
